import React, { useState, useEffect } from "react";
import { getOtherDetails, updateOtherDetails } from "../../api/User";
import { ToastContainer, toast } from "react-toastify";

const OtherDetails = () => {
  const [update, setUpdate] = useState(false);
  const [otherDetails, setOtherDetails] = useState({
    population: "",
    area: "",
    osr: "",
    other: "",
  });

  const user_id = sessionStorage.getItem("user_id");
  const token = sessionStorage.getItem("token");
  const [filterData, setFilterData] = useState([]);
  const [populationErr, setPopulationErr] = useState("");
  const [areaErr, setAreaErr] = useState("");
  const [otherErr, setOtherErr] = useState("");

  const fetchData = async () => {
    try {
      const res = await getOtherDetails(token, user_id);
      setOtherDetails(res.data[0]);
      setFilterData(res.data[0]);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleUpdate = () => setUpdate(true);
  const handleCancelUpdate = () => {
    setUpdate(false);
    fetchData();
  };

  // const handleSave = async () => {
  //   try {
  //     const formData = new FormData();
  //     formData.append("user_id", user_id);
  //     Object.keys(otherDetails).forEach((key) => {
  //       formData.append(key, otherDetails[key]);
  //     });
  //     let formDataObject = {};
  //     for (let [key, value] of formData.entries()) {
  //       formDataObject[key] = value;
  //     }

  //     const res = await updateOtherDetails(token, formDataObject);
  //     toast.success(res.message);
  //     setUpdate(false);
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error updating profile:", error);
  //     toast.error("Failed to update profile. Please try again.");
  //   }
  // };

  const handleSave = async () => {
    const { population, area, osr, other } = otherDetails;

    if (!population || population <= 0) {
      setPopulationErr("Population is required and cannot be negative");
      return;
    } else {
      setPopulationErr("");
    }

    if (!area || area <= 0) {
      setAreaErr("Area is required and cannot be negative");
      return;
    } else {
      setAreaErr("");
    }

    if ((osr == "other" || otherDetails.other !== "") && (!other || other <= 0)) {
      setOtherDetails((prevDetails) => ({
        ...prevDetails,
        other: "",
      }));
      setOtherErr("Other details are required and cannot be negative.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("user_id", user_id);
      Object.keys(otherDetails).forEach((key) => {
        formData.append(key, otherDetails[key]);
      });
      let formDataObject = {};
      for (let [key, value] of formData.entries()) {
        formDataObject[key] = value;
      }

      const res = await updateOtherDetails(token, formDataObject);
      toast.success(res.message);
      setUpdate(false);
      fetchData();
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile. Please try again.");
    }
  };

  const handleOSRChange = (e) => {
    const value = e.target.value;
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      osr: value,
      other: value === "other" ? prevDetails.other : "",
    }));
  };

  const handleOtherChange = (e) => {
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      other: e.target.value,
    }));
  };

  return (
    <div
      className="container-fluid"
      style={{ background: "#fff", overflowX: "hidden" }}
    >
      <h2 className="" style={{ top: "0", left: "0", margin: "16px", fontWeight: "bold", marginLeft: "1.5%" }}>Other Details</h2>

      <div style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        margin: "16px"
      }}>
        <div
          className="container-fluid"
          style={{ background: "#fff", overflowX: "hidden" }}
        >
          <div className="row pt-5">
            <div className="col-md-12">
              <form className="row g-3">
                <div className="col-md-4">
                  <label
                    htmlFor="population"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Population <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${populationErr ? "is-invalid" : ""}`}
                    id="population"
                    value={filterData.population}
                    disabled={!update}
                    required
                    min="1"
                    onChange={(e) => {
                      const newValue = e.target.value;

                      setFilterData({
                        ...otherDetails,
                        population: newValue,
                      });
                      setOtherDetails({
                        ...otherDetails,
                        population: newValue,
                      });

                      if (newValue == "" || newValue <= 0) {
                        setPopulationErr("Population is required and cannot be negative");
                      } else {
                        setPopulationErr("");
                      }
                    }}
                  />
                  {populationErr && <div className="invalid-feedback">{populationErr}</div>}
                </div>

                <div className="col-md-4">
                  <label
                    htmlFor="area"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Area (SQ Feet) <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    className={`form-control ${areaErr ? "is-invalid" : ""}`}
                    id="area"
                    value={filterData.area}
                    disabled={!update}
                    required
                    min="1"
                    onChange={(e) => {
                      setFilterData({ ...otherDetails, area: e.target.value });
                      setOtherDetails({ ...otherDetails, area: e.target.value });

                      if (e.target.value == "" || e.target.value <= 0) {
                        setAreaErr("Area is required and cannot be negative");
                      } else {
                        setAreaErr("");
                      }
                    }}
                  />
                  {areaErr && <div className="invalid-feedback">{areaErr}</div>}
                </div>

                <div className="col-md-4">
                  <label
                    htmlFor="area"
                    className="form-label"
                    style={{ fontWeight: "bold" }}
                  >
                    Other Source Revenue(OSR){" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className="form-select dropdown-custom"
                    value={otherDetails.osr}
                    onChange={handleOSRChange}
                    disabled={!update}
                  >
                    <option value="" disabled selected>
                      Select OSR
                    </option>
                    <option value="shop">Shop</option>
                    <option value="village_land">Village land</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {otherDetails.osr === "other" || otherDetails.other !== "" ? (
                  <div className="col-md-4">
                    <label
                      htmlFor="other"
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Enter Other Details <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="number"
                      className={`form-control ${otherErr ? "is-invalid" : ""}`}
                      id="other"
                      value={filterData.other}
                      disabled={!update}
                      min="1"
                      // onChange={handleOtherChange}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setFilterData({ ...otherDetails, other: newValue });
                        setOtherDetails({ ...otherDetails, other: newValue });

                        if (newValue == "" || newValue <= 0) {
                          setOtherErr("Other is required and cannot be negative");
                        } else {
                          setOtherErr("");
                        }
                      }}
                    />
                    {otherErr && <div className="invalid-feedback">{otherErr}</div>}
                  </div>
                ) : null}
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-end me-5 mt-5">
            {!update ? (
              <button
                type="button"
                className="btn"
                onClick={handleUpdate}
                style={{
                  width: "12%",
                  backgroundColor: "#4763E430",
                  color: "#4763E4",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#4763E4";
                  e.target.style.color = "#fff";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#4763E430";
                  e.target.style.color = "#4763E4";
                }}
              >
              Update Details 
              </button>

            ) : (
              <>
                <button
                  type="button"
                  className="btn"
                  onClick={handleSave}
                  style={{
                    width: "10%",
                    backgroundColor: "#4763E430",
                    color: "#4763E4",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }}
                >
                  Save
                </button>

                <button
                  type="button"
                  className="btn"
                  onClick={handleCancelUpdate}
                  style={{
                    width: "10%",
                    backgroundColor: "#4763E430",
                    color: "#4763E4",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#4763E4";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#4763E430";
                    e.target.style.color = "#4763E4";
                  }}
                >
                  Cancel
                </button>


              </>
            )}
          </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default OtherDetails;
